module.exports = __webpack_public_path__ + "videos/whats-new-53-hero_9x16.70106c4.mp4";